import { RESET_STATE } from 'store/global/actions';

import { COMPANY_WHITELIST_ACTION_TYPE } from '../actions';

const initialState = [];

const getItemKey = item => `${item.type}:${item.emailAddress ?? item.phoneNumber}`;

const whitelistReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_WHITELIST_ACTION_TYPE.GET_WHITELISTS:
      return payload || [];

    case COMPANY_WHITELIST_ACTION_TYPE.ADD_WHITELISTS:
      return state.concat(payload || []);

    case COMPANY_WHITELIST_ACTION_TYPE.REMOVE_WHITELISTS: {
      const removedKeys = new Set((payload || []).map(getItemKey));

      return state.filter(item => !removedKeys.has(getItemKey(item)));
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default whitelistReducer;
